import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from "@angular/forms";

export interface FilterOption {
  id: string;
  name: string;
  count?: number;
}

@Component({
  selector: "app-filter-field",
  templateUrl: "./filter-field.component.html",
  styleUrls: ["./filter-field.component.scss"],
  standalone: true,
  imports: [MaterialModule, FormsModule],
})
export class FilterFieldComponent {
  @Input() label!: string;
  @Input() totalCount!: number;
  @Input() options: FilterOption[] = [];
  @Input() selectedValue: any;
  @Input() filterKey!: string;

  @Output() valueChange = new EventEmitter<any>();
  @Output() clearFilter = new EventEmitter<string>();

  onValueChange(value: any) {
    this.valueChange.emit({ key: this.filterKey, value });
  }

  onClearFilter() {
    this.clearFilter.emit(this.filterKey);
  }
}
